<template>
    <b-row class="w-100 mt-1 px-2 no-gutters">
        <b-col class="p-2 bg-white rounded-lg d-flex">
            <b-button class="btn-circle my-auto bg-gray-light border-gray text-black" style="z-index: 10;" @click="openTimeLinePeriod()">
                <b-icon icon="clock-history" scale="0.9" />
            </b-button>
            <div class="h-100 border-right" :class="showArrow ? 'mr-5' : 'mr-4'" style="rotate: 90deg; z-index: 1;"></div>
            <b-button class="btn-circle my-auto bg-gray-light border-gray text-black position-absolute" :style="!showArrow ? 'opacity: 0; pointer-events: none' : sectionList[0]?.key == 0 ? 'opacity: .65; pointer-events: none;' : ''" style="z-index: 2; left: 3rem; top: 50%; transform: translateY(-50%);" @click="generateSectionList(-1);">
                <b-icon icon="chevron-left" scale="0.95"/>
            </b-button>
            <div v-for="section in sectionList" :key="section.key" class="d-flex pl-2" style="width: 14rem;">
                <div class="h-100 border-right mr-1" style="rotate: 90deg; z-index: 1;" />
                <b-button class="px-0 rounded border-gray"
                    :class="section.value?.Value?.Selected ? 'btn-secondary' : 'btn-gray-light'"
                    style="z-index: 2; font-size: .65rem; width: 13.2rem;"
                    @click="$emit('SectionSelectedEvent', section.key);">
                    <div class="d-flex h-100 w-100 p-0" 
                        :style="section.value?.Value?.Selected ? '' : 'color: var(--Variant);'">
                        <div class="mx-2 my-auto">
                            <b-icon icon="calendar-event" style="height: 0.75rem; width: 0.75rem;" />
                        </div>
                        <div v-html="allocationUtils.GeneratePeriodLabel(section.value?.Value?.StartDate, section.value?.Value?.EndDate)" class="my-auto text-left" style="width: 80%;" />
                        <div v-if="Sections.length > 1 && CheckWriteAction" class="my-auto px-1" @click.stop="deletePeriod(section.key)">
                            <b-icon icon="x" scale="1.5" class="text-danger" /> 
                        </div>
                    </div>
                </b-button>
            </div>
            <b-button class="btn-circle my-auto bg-gray-light border-gray text-black position-absolute" :style="!showArrow ? 'opacity: 0; pointer-events: none' : sectionList[sectionList.length - 1]?.key == Sections.length - 1 ? 'opacity: .65; pointer-events: none;' : ''"  style="z-index: 2; right: 1rem; top: 50%; transform: translateY(-50%);" @click="generateSectionList(1);">
                <b-icon icon="chevron-right" scale="0.95"/>
            </b-button>
        </b-col>

        <b-modal id="modal" :size="showPeriods ? 'lg' : 'md'"  v-model="openTimeLine" centered no-close-on-backdrop no-close-on-esc>
            <template #modal-header>
                <div class="h-100 w-100 d-flex justify-content-between align-items-center">
                    <h6 class="text-left w-100" style="font-weight: bold;">{{ showPeriods ? $t('AddPeriod') : $t('TimeLine')}}</h6>
                    <b-icon v-if="!showPeriods" icon="x" scale="1.5" role="button" @click="updatePeriod(false)"/> 
                </div>
            </template>
            <div class="d-flex">
                <b-card no-body :class="showPeriods ? 'w-50' : 'w-100'">
                    <b-card-header>
                        <b-card-title>
                            {{ $t('PeriodsList') }}
                        </b-card-title>
                    </b-card-header>
                    <b-card-body :class="showPeriods ? 'd-flex' : ''">
                        <div v-if="!showPeriods" class="d-flex justify-content-center">
                            <b-button @click="showPeriodsModal()" :variant="'outline-' + Variant" pill class="d-flex my-auto ">
                                <b-icon icon="plus" class="my-auto" scale="1.1"/> 
                                <div class="my-auto">{{ $t('AddNewPeriod') }}</div>
                            </b-button>
                        </div>
                        <div class="w-100 my-auto">
                            <AllocationTimeLine :Periods="tempSection.map(u => u.Value)" Variant="bg-white" :WriteAction="!showPeriods" ref="timeLine" @update-date="updateDate"/>
                        </div>
                     </b-card-body>
                </b-card>
                <b-card no-body v-if="showPeriods" class="w-50 mx-2">
                    <b-card-header class="d-flex justify-content-between">
                        <b-card-title>
                            {{ $t('SetUpPivotPoint') }}
                        </b-card-title>
                        <b-icon icon="x" scale="1.7" role="button" class="text-danger text-right" @click="hidePeriodsModal();" />
                    </b-card-header>
                    <b-card-body>
                        <b-card no-body>
                            <b-card-header>
                                <b-card-sub-title>
                                    {{ $t('SetUpPivotPeriod') }}
                                </b-card-sub-title>
                            </b-card-header>
                            <b-card-body class="border rounded">
                                <b-form>
                                    <b-form-group
                                        :label="$t('Date')"
                                        label-class="my-auto"
                                        label-cols-sm="2">
                                        <b-input-group>
                                            <b-form-input
                                                v-model="selectedPeriod"
                                                button-only autofocus right locale="fr" type="date" />
                                        </b-input-group>
                                    </b-form-group>
                                    <b-form-group>
                                        <template #label>
                                            <div class="mt-2">{{ $t('PeriodDuplicationSegment') }}
                                                <b-icon icon="info-circle" />
                                            </div>
                                        </template>
                                        <div class="d-flex my-2">
                                            <b-button :variant="!segmentPeriod ? 'outline-' + Variant : Variant" class="mx-1 w-50" @click="segmentPeriod = true">{{ $t('Before') }}</b-button>
                                            <b-button :variant="segmentPeriod ? 'outline-' + Variant : Variant" class="mx-1 w-50" @click="segmentPeriod = false">{{ $t('After') }}</b-button>
                                        </div>
                                    </b-form-group>
                                    <b-form-group :label="$t('NewPeriodPreview')">
                                        <div v-html="getViewPeriods()" class="w-100 p-2 mt-2 bg-white" style="height: 2.1rem" />
                                    </b-form-group>
                                </b-form>
                            </b-card-body>
                        </b-card>
                         <b-card no-body>
                            <b-card-header>
                                <b-card-sub-title>
                                    {{ $t('SetUpAllocation') }}
                                </b-card-sub-title>
                            </b-card-header>
                            <b-card-body class="border rounded">
                                <b-form>
                                    <b-form-group :label="$t('AllocationType')">
                                        <div class="d-flex my-2">
                                            <b-button :variant="refPeriod ? 'outline-' + Variant : Variant" class="mx-1 w-50" @click="refPeriod = false;">{{ $t('New') }}</b-button>
                                            <b-button :variant="!refPeriod ? 'outline-' + Variant : Variant" class="mx-1 w-50" @click="refPeriod = true">{{ $t('PeriodDuplicate') }}</b-button>
                                        </div>
                                    </b-form-group>
                                    <b-form-group :label="$t('ReferencePeriod')">
                                        <b-form-select class="my-2" v-model="duplicateSection" :disabled="!refPeriod">
                                            <b-form-select-option v-for="(section, index) in Sections" :key="index" :value="index">
                                                <div v-if="refPeriod" v-html="allocationUtils.GeneratePeriodLabel(section.Value?.StartDate, section.Value?.EndDate)" />
                                            </b-form-select-option>
                                        </b-form-select>
                                    </b-form-group>
                                </b-form>
                            </b-card-body>
                        </b-card>
                    </b-card-body>
                    <b-card-footer class="d-flex">
                        <b-button :variant="Variant" pill class="mx-auto w-25" @click="addPeriods()">{{ $t('Add') }}</b-button>
                    </b-card-footer>
                </b-card>
            </div>
            <template #modal-footer>
                <b-button v-if="!showPeriods" @click="updatePeriod(false)" :variant="'outline-' + Variant" pill>{{$t('Cancel')}}</b-button>
                <b-button v-if="!showPeriods" @click="updatePeriod(true)" :variant="Variant" pill>{{$t('Submit')}}</b-button>
            </template>
        </b-modal>
    </b-row>
</template>

<script lang="ts">
    import { Prop, Component, Watch } from 'vue-property-decorator'; 
    import locales from "../locales/Allocation.json"; 
    import { mixins } from 'vue-class-component';
    import Section from '@/types/fields/Section'
    import Period from '@/types/Period';
    import Dictionary from '@/types/Dictionary';
    import IField from '@/interfaces/IField';
    import AllocationUtils from './AllocationUtils';
    import AllocationTimeLine from './AllocationTimeLine.vue';
    import FieldTypeEnum from '@/enums/fields/FieldTypeEnum';
    import GraphNode from '@/types/fields/GraphNode';
    import GraphEdge from '@/types/fields/GraphEdge';
    import { LinkUtils } from '@/components/commons/Utils';
    import { BaseObjectForm } from '../BaseObjectForm';
    import FormDraft from '@/types/fields/FormDraft';
    
    @Component({
        components: {
            AllocationTimeLine,
        },
        i18n: { messages: locales }
    })
    export default class AllocationPeriods extends mixins(LinkUtils, BaseObjectForm<FormDraft<Section<Period, Dictionary<IField[]>>>>)
    {
        @Prop()
        public Sections!: Section<Period, Dictionary<IField[]>>[];

        @Prop()
        public IndexWidth!: number;

        @Prop()
        public CheckWriteAction!: boolean;

        @Prop()
        public CheckDeleteAction!: boolean;

        private sectionList: { key: number, value: Section<Period, Dictionary<IField[]>> }[] = [];
        private allocationUtils: AllocationUtils = {} as AllocationUtils;
        private indexAllocation: number = 0;
        private showArrow: boolean = false;

        private tempSection: Section<Period, Dictionary<IField[]>>[] = [];
        private oldTempSection: Section<Period, Dictionary<IField[]>>[] = [];

        @Watch('IndexWidth')
        @Watch('Sections', {deep: true})
        private callGenerateSectionList() : void
        {
            this.generateSectionList();
        }

        private generateSectionList(index?: number) : void
        {
            let _sectionStart: number = 0;
            this.showArrow = false;

            if(this.Sections?.length > this.IndexWidth)
            {
                this.showArrow = true;
                
                if(index == undefined)
                {
                    if (this.Sections.findIndex(u => u.Value.Selected) > this.Sections.length - this.IndexWidth) 
                    {
                        _sectionStart = this.Sections.length - this.IndexWidth;
                    } 
                    else if (this.Sections.findIndex(u => u.Value.Selected) > this.IndexWidth) 
                    {
                        _sectionStart = this.Sections.findIndex(u => u.Value.Selected) - 2;
                    }
                } 
                else if (this.sectionList.length > 0)
                {
                    let minIndex: number = this.sectionList.map(y => y.key).reduce((a, b) => Math.min(a, b));
                    let maxIndex: number = this.sectionList.map(y => y.key).reduce((a, b) => Math.max(a, b));

                    _sectionStart = minIndex;

                    if(minIndex + index >= 0 && maxIndex + index < this.Sections.length)
                        _sectionStart += index;    
                }
            }

            this.sectionList = [];

            for(let i = _sectionStart; i < _sectionStart + this.IndexWidth; i++)
            {
                if(this.Sections[i])
                    this.sectionList.push( { key: i, value: this.Sections[i] } );
            }
        }

        private openTimeLine: boolean = false;

        private openTimeLinePeriod() : void
        {
            this.tempSection = this.allocationUtils.DeepClone<Section<Period, Dictionary<IField[]>>[]>(this.Sections);
            this.openTimeLine = true;
        }
        
        private updatePeriod(valid: boolean) : void
        {
            if(valid)
            {
                this.closeInputTimeLine();
                this.$emit('AddSectionEvent', this.tempSection);
            }

            this.openTimeLine = false;
        };

        private closeInputTimeLine(event?: MouseEvent) : void
        {
            let allocationTimeLine: AllocationTimeLine = this.$refs['timeLine'] as AllocationTimeLine;

            // Event fait référence au click, si je clique sur le même input ne le ferme pas
            if(allocationTimeLine && (!event || (event.target as HTMLInputElement).type != "date"))
                allocationTimeLine.closeInput();
        };


        private refPeriod: boolean = false;
        private duplicateSection: number = null;
        private showPeriods: boolean = false;
        private segmentPeriod: boolean = false;
        private selectedPeriod: Date = new Date();

        private showPeriodsModal() : void
        {
            this.duplicateSection = null;
            this.refPeriod = false;
            this.showPeriods = !this.showPeriods;
            this.selectedPeriod = null;
            this.oldTempSection = this.allocationUtils.DeepClone<Section<Period, Dictionary<IField[]>>[]>(this.tempSection);
        }

        private hidePeriodsModal() : void
        {
            this.duplicateSection = null;
            this.refPeriod = false;
            this.showPeriods = false;
            this.selectedPeriod = null;
            this.tempSection = this.allocationUtils.DeepClone<Section<Period, Dictionary<IField[]>>[]>(this.oldTempSection);
            if(this.tempSection.find(u => u.Value.Selected === true) == null)
                this.tempSection[this.tempSection.length - 1].Value.Selected = true;
        }

        private addPeriods() : void
        {
            let _selectedDate: Date = new Date(this.selectedPeriod);
            let _validDate: {key: boolean, value: string} = this.allocationUtils.IsValidDate(_selectedDate);

            if(!_validDate.key)
            {
                this.$bvToast.toast(this.$t('MsgPivotPointDate', { pivotPointDate: _validDate.value }).toString(), 
                {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });

                this.tempSection = this.allocationUtils.DeepClone<Section<Period, Dictionary<IField[]>>[]>(this.oldTempSection);
            } 
            else 
            {
                let _graphNodes: GraphNode<TAllocation>[] = [];
                let _graphEdges: GraphEdge[] = [];

                if(this.duplicateSection !== null && this.refPeriod)
                {
                    if(this.Sections[this.duplicateSection].Fields[edgesField] != null)
                        _graphEdges = JSON.parse(JSON.stringify(this.Sections[this.duplicateSection].Fields[edgesField]));

                    JSON.parse(JSON.stringify(this.Sections[this.duplicateSection].Fields[nodesField])).forEach(node => 
                    {
                        if(node.Column === 2)
                        {
                            let index: string = (--this.indexAllocation).toString();
                            _graphEdges.filter(u => u.To === node.Id).forEach(i => i.To = index);
                            _graphEdges.filter(u => u.From === node.Id).forEach(i => i.From = index);

                            node.Id = index;
                            node.Value.Id = index;
                        }
                        _graphNodes.push(node);
                    });
                }

                let _fields: Dictionary<IField[]> = {};
                _fields[nodesField] = _graphNodes;
                _fields[edgesField] = _graphEdges;
        
                this.tempSection.find(u => u.Value.Selected).Fields = _fields;
            }
            
            this.showPeriodsModal();
        }

        private getViewPeriods() : string
        {
            if(this.selectedPeriod)
            {
                let _startDate: Date = null;
                let _endDate: Date = null;

                if(this.segmentPeriod)
                {
                    _endDate = this.selectedPeriod;
                    _startDate = this.tempSection.map(u => u.Value)?.find(u => new Date(u.EndDate).getTime() === new Date(this.selectedPeriod).getTime())?.StartDate;
                } 
                else 
                {
                    _startDate = this.selectedPeriod;
                    _endDate = this.tempSection.map(u => u.Value)?.find(u => new Date(u.StartDate).getTime() === new Date(this.selectedPeriod).getTime())?.EndDate;
                }

                return this.allocationUtils.GeneratePeriodLabel(_startDate, _endDate);
            }
        }

        @Watch('segmentPeriod')
        @Watch('selectedPeriod')
        private addTempPeriod() : void
        {
            let _selectedDate: Date = new Date(this.selectedPeriod);

            if(this.selectedPeriod != null
                && this.allocationUtils.IsValidDate(_selectedDate).key == true)
            {
                this.tempSection.map(u => u.Value).forEach(u => u.Selected = false);
                this.tempSection = this.allocationUtils.DeepClone<Section<Period, Dictionary<IField[]>>[]>(this.oldTempSection);
                let _firstPeriod: Period[] = [];
                let _lastPeriod: Period[] = [];
                let _newSections: Section<Period, Dictionary<IField[]>>[] = [];
                let _firstDate: Date = new Date(this.oldTempSection.map(u => u.Value).sort((a, b) => new Date(a.StartDate).getTime() - new Date(b.StartDate).getTime())[0].StartDate);

                if(_selectedDate != null)
                {
                    let _day: number = _selectedDate.getDate();
                    let _month: number = _selectedDate.getMonth();
                    let _year: number = _selectedDate.getFullYear();

                    if(this.oldTempSection.find(u => 
                        new Date(u.Value.StartDate).getDate() == _day 
                        && new Date(u.Value.StartDate).getMonth() == _month
                        && new Date(u.Value.StartDate).getFullYear() == _year
                        || new Date(u.Value.EndDate).getDate() == _day
                        && new Date(u.Value.EndDate).getMonth() == _month
                        && new Date(u.Value.EndDate).getFullYear() == _year))
                    {
                        this.$bvToast.toast(this.$t('PeriodAddingDisallowed').toString(), 
                        {
                            title: this.$t('Error').toString(),
                            autoHideDelay: 10000,
                            variant: "danger",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                        this.selectedPeriod = null;
                        return;
                    }

                    if(_selectedDate.getTime() < _firstDate.getTime())
                    {
                        this.segmentPeriod = false;

                        let _indexSection: number = this.tempSection.indexOf(this.tempSection.find(u => new Date(u.Value.StartDate).getDate() == _selectedDate.getDate() && new Date(u.Value.StartDate).getMonth() == _selectedDate.getMonth() && new Date(u.Value.StartDate).getFullYear() == _selectedDate.getFullYear()));
                        
                        if(_indexSection != -1)
                        {
                            this.tempSection.splice(_indexSection, 1);
                        }
                            
                        _newSections.push(new Section<Period, Dictionary<IField[]>>(
                            this.Sections[0].Name, 
                            this.Sections[0].Label, 
                            {} as Dictionary<IField[]>, 
                            true, 
                            {StartDate: _selectedDate, EndDate: _firstDate, Selected: true}
                        ));
                    } 
                    else 
                    {
                        _firstPeriod = this.tempSection.map(u => u.Value).filter(u => new Date(u.StartDate).getTime() < _selectedDate.getTime()).sort((a, b) => new Date(b.StartDate).getTime() - new Date(a.StartDate).getTime());
                        _lastPeriod = this.tempSection.map(u => u.Value).filter(u => new Date(u.EndDate).getTime() > _selectedDate.getTime()).sort((a, b) => new Date(a.EndDate).getTime() - new Date(b.EndDate).getTime());

                        let _period: Period = {StartDate: _firstPeriod?.length > 0 ? _firstPeriod[0].StartDate : null, EndDate: _lastPeriod?.length > 0 ? _lastPeriod[0].EndDate : null, Selected: false}

                        let _indexSection: number = this.tempSection.indexOf(this.tempSection.find(u => new Date(u.Value.StartDate).getTime() == new Date(_period.StartDate).getTime()));
                        if(_indexSection != -1)
                        {                                                
                            _newSections.push(new Section<Period, Dictionary<IField[]>>(
                                this.Sections[0].Name, 
                                this.Sections[0].Label, 
                                this.segmentPeriod ? {} as Dictionary<IField[]> : this.tempSection[_indexSection].Fields,
                                true, 
                                {StartDate: _period.StartDate, EndDate: _selectedDate, Selected: this.segmentPeriod ? true : false} as Period
                            ));
                            _newSections.push(new Section<Period, Dictionary<IField[]>>(
                                this.Sections[0].Name, 
                                this.Sections[0].Label, 
                                this.segmentPeriod ? this.tempSection[_indexSection].Fields : {} as Dictionary<IField[]>, 
                                true, 
                                {StartDate: _selectedDate, EndDate: _period.EndDate, Selected: this.segmentPeriod ? false : true}
                            ));
                            this.tempSection.splice(_indexSection, 1);
                        }
                    }

                    if(_newSections.length > 0)
                    {
                        this.tempSection.push(..._newSections);
                        this.tempSection.sort((a, b) => new Date(a.Value.StartDate).getTime() - new Date(b.Value.StartDate).getTime())       
                    }
                }
            }
        }

        private updateDate(index: number, newDate: Date) : void
        {
            // /!\ Obligé d'utiliser splice pour ne pas mettre à jour les références
            let _firstSection: Section<Period, Dictionary<IField[]>> = this.tempSection[index - 1];
            if(_firstSection)
            {
                this.tempSection.splice(this.tempSection.indexOf(_firstSection), 1, new Section<Period, Dictionary<IField[]>>(
                    _firstSection.Name,
                    _firstSection.Label,
                    _firstSection.Fields,
                    true,
                    { StartDate: _firstSection.Value.StartDate, EndDate: newDate, Selected: _firstSection.Value.Selected }
                ));
            };


            let _secondSection: Section<Period, Dictionary<IField[]>> = this.tempSection[index];
            if(_secondSection)
            {
                this.tempSection.splice(this.tempSection.indexOf(_secondSection), 1, new Section<Period, Dictionary<IField[]>>(
                    _secondSection.Name,
                    _secondSection.Label,
                    _secondSection.Fields,
                    true,
                    { StartDate: newDate, EndDate: _secondSection.Value.EndDate, Selected: _secondSection.Value.Selected }
                ));
            };
                
        }

        private deletePeriod(index: number) : void
        {
            this.$emit('SectionDeletedEvent', index, this.Sections)
        }

        created()
        {
            this.allocationUtils = new AllocationUtils(this.$i18n);
            this.generateSectionList(undefined);
        }

        mounted()
        {
            window.addEventListener("click", this.closeInputTimeLine)
        }

        beforeDestroy()
        {
            window.removeEventListener("click", this.closeInputTimeLine)
        }
    }

    /** Clé du dictionnaire des Fields contenant les Nodes */
    const nodesField: string = FieldTypeEnum[FieldTypeEnum.Node].toString();
    /** Clé du dictionnaire des Fields contenant les Edges */
    const edgesField: string = FieldTypeEnum[FieldTypeEnum.Edge].toString();

    class TAllocation {
        Id: string;
        Usage: number;
        Percentage: number;
        StartDay?: number;
        StartMonth?: number;
        EndDay?: number;
        EndMonth?: number;
        IsRecurring?: boolean;
    }
</script>

<style>
</style>